import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { pick } from 'lodash';

import FileStackImage from 'misc/filestack_image';
import Banner from './Banner';

const AsyncCertificationBadgeIcon = React.lazy(() =>
  import(
    /* webpackChunkName: "CertificationBadgeIcon" */ './CertificationBadgeIcon'
  ),
);

const DEFAULT_HEIGHT = 112;
const DEFAULT_WIDTH = 86;

const CertificationBadge = ({
  height,
  width,
  iconName,
  foregroundColor,
  backgroundColor,
  image,
  onLoadComplete,
}) => {
  let filestackImage = null;
  if (image) {
    filestackImage = new FileStackImage({
      ...pick(image, ['signature', 'policy', 'handle']),
      transform: {
        resize: {
          fit: 'max',
          align: 'center',
          height: height || DEFAULT_HEIGHT,
          width: width || DEFAULT_WIDTH,
        },
      },
    });

    return (
      <img
        className="of-contain"
        height={height || DEFAULT_HEIGHT}
        width={width || DEFAULT_WIDTH}
        onLoad={onLoadComplete}
        src={image.bssSignedUrl || filestackImage.url}
        alt={image.name}
        title="badge"
      />
    );
  }

  return (
    <Banner
      height={height}
      width={width}
      foregroundColor={foregroundColor}
      backgroundColor={backgroundColor}
    >
      <Suspense fallback={null}>
        <AsyncCertificationBadgeIcon
          name={iconName}
          fill={foregroundColor}
          onLoadComplete={onLoadComplete}
        />
      </Suspense>
    </Banner>
  );
};

CertificationBadge.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  iconName: PropTypes.string,
  backgroundColor: PropTypes.string,
  foregroundColor: PropTypes.string,
};

export const CertificationBadgeIcon = props => (
  <Suspense fallback={null}>
    <AsyncCertificationBadgeIcon {...props} />
  </Suspense>
);
export default CertificationBadge;
